import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { BookOpenIcon, FlaskConicalIcon, HeartPulseIcon, UtensilsIcon, CheckIcon, WalletIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="bonos" className="py-24 px-4 bg-[#0a0e1a]" data-id="element-122">
      <div className="max-w-5xl mx-auto" data-id="element-123">
        {/* Intro Text */}
        <FadeIn data-id="element-124">
          <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-125">
            <h2 className="text-3xl md:text-5xl font-bold text-[#f5f5f5] mb-6 leading-tight" data-id="element-126">
              No quiero que solo leas un libro. Quiero que tengas{' '}
              <span className="text-[#c9a84c]" data-id="element-127">
                resultados biológicos reales
              </span>{' '}
              en los próximos 28 días.
            </h2>
            <p className="text-xl text-[#9ca3af]" data-id="element-128">
              Por eso, si tomas acción en los próximos{' '}
              <strong className="text-[#dc2626] font-bold" data-id="element-129">05:47</strong>{' '}
              minutos, voy a incluir estos 3 potentes aceleradores de forma
              completamente <strong className="text-[#c9a84c]" data-id="element-130">GRATUITA</strong>
              :
            </p>
          </div>
        </FadeIn>

        {/* Main Grid: Image Left, Cards Right */}
        <div className="grid lg:grid-cols-12 gap-8 items-start mb-16" data-id="element-131">
          {/* Left Column: Sticky Image */}
          <FadeIn delay={0.1} className="lg:col-span-5" data-id="element-132">
            <div className="sticky top-24" data-id="element-133">
              <img src="https://cdn.magicpatterns.com/uploads/mKrxWce1FESZFt9hJ19F2j/heylloyd-image-1772818255775.png" alt="Código Alfa 40+ Bundle" className="w-full h-auto rounded-2xl shadow-[0_0_40px_rgba(201,168,76,0.15)] border border-[#c9a84c]/20" data-id="element-134" />
            </div>
          </FadeIn>

          {/* Right Column: Cards */}
          <div className="lg:col-span-7 space-y-6" data-id="element-135">
            {/* Ebook Principal */}
            <FadeIn delay={0.2} data-id="element-136">
              <div className="bg-gradient-to-r from-[#111827] to-[#0a0e1a] border border-[#c9a84c] p-6 rounded-xl flex gap-4 items-start shadow-[0_0_20px_rgba(201,168,76,0.1)]" data-id="element-137">
                <BookOpenIcon className="w-8 h-8 text-[#c9a84c] shrink-0 mt-1" data-id="element-138" />
                <div className="flex-grow" data-id="element-139">
                  <div className="flex flex-wrap justify-between items-baseline gap-2 mb-2" data-id="element-140">
                    <h3 className="text-xl font-bold text-[#f5f5f5]" data-id="element-141">
                      Ebook Principal: Código Alfa 40+
                    </h3>
                    <span className="text-[#9ca3af] line-through text-sm" data-id="element-142">
                      Valor: $97
                    </span>
                  </div>
                  <p className="text-[#9ca3af]" data-id="element-143">
                    El mapa exacto de 28 días para tu reajuste hormonal.
                  </p>
                </div>
              </div>
            </FadeIn>

            {/* BONO #1 */}
            <FadeIn delay={0.3} data-id="element-144">
              <div id="bono-1" className="bg-[#111827] border border-[#c9a84c]/30 p-6 rounded-xl shadow-lg" data-id="element-145">
                <div className="flex items-start gap-4 mb-4" data-id="element-146">
                  <div className="bg-[#c9a84c]/10 p-3 rounded-lg shrink-0" data-id="element-147">
                    <FlaskConicalIcon className="w-6 h-6 text-[#c9a84c]" data-id="element-148" />
                  </div>
                  <div className="flex-grow" data-id="element-149">
                    <h3 className="text-xl font-bold text-[#f5f5f5] mb-1" data-id="element-150">
                      BONO #1: Guía de Suplementos Alfa (Edición Latam)
                    </h3>
                    <div className="flex flex-wrap items-center gap-2 text-sm" data-id="element-151">
                      <span className="text-[#9ca3af]" data-id="element-152">
                        Normalmente vendido por:{' '}
                        <span className="line-through" data-id="element-153">$47 USD</span>
                      </span>
                      <span className="bg-green-500/20 text-green-400 font-bold px-2 py-0.5 rounded text-xs uppercase tracking-wide border border-green-500/30" data-id="element-154">
                        HOY: GRATIS
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-[#9ca3af] mb-4 text-sm leading-relaxed" data-id="element-155">
                  ¿Sabías que el 90% de los suplementos que venden en la
                  farmacia de tu esquina son basura con buen marketing? Peor
                  aún, muchos están cargados de rellenos que elevan tu
                  estrógeno. En esta guía te revelo:
                </p>
                <ul className="space-y-3" data-id="element-156">
                  <li className="flex items-start gap-3" data-id="element-157">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-158" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-159">
                      <strong className="text-[#f5f5f5]" data-id="element-160">
                        El "Tridente de Oro":
                      </strong>{' '}
                      Los 3 minerales exactos que tu cuerpo necesita para
                      fabricar testosterona y que puedes conseguir en cualquier
                      farmacia por menos de lo que cuesta un café.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-161">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-162" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-163">
                      <strong className="text-[#f5f5f5]" data-id="element-164">
                        Hacks de Compra en Latam:
                      </strong>{' '}
                      Cómo identificar marcas reales y evitar las estafas de los
                      "testo-boosters" químicos.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-165">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-166" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-167">
                      <strong className="text-[#f5f5f5]" data-id="element-168">
                        Dosis de Guerra:
                      </strong>{' '}
                      Cuánto y cuándo tomar cada cosa para ver resultados en
                      energía desde la primera semana.
                    </span>
                  </li>
                </ul>
              </div>
            </FadeIn>

            {/* BONO #2 */}
            <FadeIn delay={0.4} data-id="element-169">
              <div className="bg-[#111827] border border-[#c9a84c]/30 p-6 rounded-xl shadow-lg" data-id="element-170">
                <div className="flex items-start gap-4 mb-4" data-id="element-171">
                  <div className="bg-[#c9a84c]/10 p-3 rounded-lg shrink-0" data-id="element-172">
                    <HeartPulseIcon className="w-6 h-6 text-[#c9a84c]" data-id="element-173" />
                  </div>
                  <div className="flex-grow" data-id="element-174">
                    <h3 className="text-xl font-bold text-[#f5f5f5] mb-1" data-id="element-175">
                      BONO #2: Protocolo 'Libido de Acero'
                    </h3>
                    <div className="flex flex-wrap items-center gap-2 text-sm" data-id="element-176">
                      <span className="text-[#9ca3af]" data-id="element-177">
                        Normalmente vendido por:{' '}
                        <span className="line-through" data-id="element-178">$47 USD</span>
                      </span>
                      <span className="bg-green-500/20 text-green-400 font-bold px-2 py-0.5 rounded text-xs uppercase tracking-wide border border-green-500/30" data-id="element-179">
                        HOY: GRATIS
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-[#9ca3af] mb-4 text-sm leading-relaxed" data-id="element-180">
                  No es tu edad, es tu sistema circulatorio. Este protocolo de
                  biohacking sexual te enseña a optimizar el flujo sanguíneo de
                  forma natural:
                </p>
                <ul className="space-y-3" data-id="element-181">
                  <li className="flex items-start gap-3" data-id="element-182">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-183" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-184">
                      <strong className="text-[#f5f5f5]" data-id="element-185">
                        El Biohack del Óxido Nítrico:
                      </strong>{' '}
                      Alimentos y respiraciones específicas que funcionan mejor
                      que la "pastillita azul", sin efectos secundarios ni
                      riesgos cardíacos.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-186">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-187" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-188">
                      <strong className="text-[#f5f5f5]" data-id="element-189">
                        Reset de Dopamina:
                      </strong>{' '}
                      Cómo reconfigurar tu cerebro para recuperar el deseo y la
                      potencia que sentías a los 20 años.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-190">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-191" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-192">
                      <strong className="text-[#f5f5f5]" data-id="element-193">
                        Erecciones Matutinas:
                      </strong>{' '}
                      El termómetro real de tu salud masculina y cómo asegurarte
                      de que vuelvan a ser la norma, no la excepción.
                    </span>
                  </li>
                </ul>
              </div>
            </FadeIn>

            {/* BONO #3 */}
            <FadeIn delay={0.5} data-id="element-194">
              <div className="bg-[#111827] border border-[#c9a84c]/30 p-6 rounded-xl shadow-lg" data-id="element-195">
                <div className="flex items-start gap-4 mb-4" data-id="element-196">
                  <div className="bg-[#c9a84c]/10 p-3 rounded-lg shrink-0" data-id="element-197">
                    <UtensilsIcon className="w-6 h-6 text-[#c9a84c]" data-id="element-198" />
                  </div>
                  <div className="flex-grow" data-id="element-199">
                    <h3 className="text-xl font-bold text-[#f5f5f5] mb-1" data-id="element-200">
                      BONO #3: Cheat-Sheet del Restaurante Latino
                    </h3>
                    <div className="flex flex-wrap items-center gap-2 text-sm" data-id="element-201">
                      <span className="text-[#9ca3af]" data-id="element-202">
                        Normalmente vendido por:{' '}
                        <span className="line-through" data-id="element-203">$47 USD</span>
                      </span>
                      <span className="bg-green-500/20 text-green-400 font-bold px-2 py-0.5 rounded text-xs uppercase tracking-wide border border-green-500/30" data-id="element-204">
                        HOY: GRATIS
                      </span>
                    </div>
                  </div>
                </div>
                <p className="text-[#9ca3af] mb-4 text-sm leading-relaxed" data-id="element-205">
                  Ser un Alfa no significa comer pollo y brócoli en un tupper
                  mientras tus amigos disfrutan. Con esta guía de bolsillo
                  sabrás exactamente qué pedir en el asado, la taquería o la
                  cena de negocios:
                </p>
                <ul className="space-y-3" data-id="element-206">
                  <li className="flex items-start gap-3" data-id="element-207">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-208" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-209">
                      <strong className="text-[#f5f5f5]" data-id="element-210">
                        El Semáforo Hormonal:
                      </strong>{' '}
                      Qué cortes de carne y grasas tradicionales son "Gasolina
                      Alfa" y cuáles son veneno inflamatorio.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-211">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-212" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-213">
                      <strong className="text-[#f5f5f5]" data-id="element-214">
                        El Hack de las Bebidas:
                      </strong>{' '}
                      Cómo disfrutar de un trago social sin desplomar tu
                      testosterona ni acumular grasa abdominal.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-215">
                    <CheckIcon className="w-5 h-5 text-[#c9a84c] shrink-0 mt-0.5" data-id="element-216" />
                    <span className="text-[#d1d5db] text-sm leading-relaxed" data-id="element-217">
                      <strong className="text-[#f5f5f5]" data-id="element-218">Regla de Oro:</strong>{' '}
                      Cómo navegar cualquier menú de México, Colombia o
                      Argentina y salir de ahí más fuerte de lo que entraste.
                    </span>
                  </li>
                </ul>
              </div>
            </FadeIn>
          </div>
        </div>

        {/* Summary Section */}
        <FadeIn delay={0.6} data-id="element-219">
          <div className="bg-gradient-to-b from-[#111827] to-[#0a0e1a] border-2 border-[#c9a84c] rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(201,168,76,0.15)] max-w-4xl mx-auto relative overflow-hidden" data-id="element-220">
            {/* Background Glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-[#c9a84c]/10 blur-[50px] pointer-events-none" data-id="element-221" />

            <div className="relative z-10" data-id="element-222">
              <div className="flex items-center justify-center gap-3 mb-8" data-id="element-223">
                <WalletIcon className="w-8 h-8 text-[#c9a84c]" data-id="element-224" />
                <h3 className="text-2xl md:text-3xl font-bold text-[#f5f5f5] text-center uppercase tracking-wide" data-id="element-225">
                  Resumen de tu Transformación
                </h3>
              </div>

              <div className="space-y-4 mb-8" data-id="element-226">
                <div className="flex justify-between items-center border-b border-gray-800 pb-4" data-id="element-227">
                  <span className="text-[#d1d5db] font-medium" data-id="element-228">
                    Ebook Principal: Código Alfa 40+
                  </span>
                  <span className="text-[#9ca3af]" data-id="element-229">Valor: $97</span>
                </div>
                <div className="flex justify-between items-center border-b border-gray-800 pb-4" data-id="element-230">
                  <span className="text-[#d1d5db] font-medium" data-id="element-231">
                    Bono 1: Guía Suplementos Latam
                  </span>
                  <div className="flex items-center gap-2" data-id="element-232">
                    <span className="text-[#9ca3af] line-through" data-id="element-233">
                      Valor: $47.00
                    </span>
                    <span className="bg-[#c9a84c]/20 text-[#c9a84c] font-bold px-2 py-0.5 rounded text-xs uppercase border border-[#c9a84c]/30" data-id="element-234">
                      GRATIS
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center border-b border-gray-800 pb-4" data-id="element-235">
                  <span className="text-[#d1d5db] font-medium" data-id="element-236">
                    Bono 2: Protocolo Libido de Acero
                  </span>
                  <div className="flex items-center gap-2" data-id="element-237">
                    <span className="text-[#9ca3af] line-through" data-id="element-238">
                      Valor: $47.00
                    </span>
                    <span className="bg-[#c9a84c]/20 text-[#c9a84c] font-bold px-2 py-0.5 rounded text-xs uppercase border border-[#c9a84c]/30" data-id="element-239">
                      GRATIS
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center border-b border-gray-800 pb-4" data-id="element-240">
                  <span className="text-[#d1d5db] font-medium" data-id="element-241">
                    Bono 3: Cheat-Sheet Restaurante
                  </span>
                  <div className="flex items-center gap-2" data-id="element-242">
                    <span className="text-[#9ca3af] line-through" data-id="element-243">
                      Valor: $47.00
                    </span>
                    <span className="bg-[#c9a84c]/20 text-[#c9a84c] font-bold px-2 py-0.5 rounded text-xs uppercase border border-[#c9a84c]/30" data-id="element-244">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>

              <div className="text-center space-y-4" data-id="element-245">
                <div className="text-xl text-[#9ca3af]" data-id="element-246">
                  VALOR TOTAL:{' '}
                  <span className="line-through decoration-[#dc2626] decoration-2" data-id="element-247">
                    $238 USD
                  </span>
                </div>

                <div className="py-4" data-id="element-248">
                  <div className="text-sm font-bold text-[#c9a84c] uppercase tracking-widest mb-2" data-id="element-249">
                    Precio de Lanzamiento Hoy:
                  </div>
                  <div className="text-5xl md:text-7xl font-extrabold text-[#f5f5f5] drop-shadow-[0_0_15px_rgba(201,168,76,0.5)]" data-id="element-250">
                    SOLO $9.99{' '}
                    <span className="text-2xl text-[#c9a84c]" data-id="element-251">USD</span>
                  </div>
                </div>

                <p className="text-[#9ca3af] italic text-sm md:text-base max-w-lg mx-auto mb-8" data-id="element-252">
                  (Es menos de lo que gastas en una comida rápida que te está
                  bajando la testosterona)
                </p>

                <Button href="https://www.tumomentovital.com/cart/47616565608640:1" onClick={() => {
                if ((window as any).fbq) {
                  ;
                  (window as any).fbq('track', 'AddToCart');
                }
              }} className="w-full text-xl py-6 shadow-[0_0_30px_rgba(201,168,76,0.4)]" data-id="element-253">
                  SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA
                </Button>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}